import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UsersDashboardInfoResponse } from '@edtech-ui/core/models/admin-panel/admin-panel-models';
import { AdminDashboardService } from '@edtech-ui/core/services/admin-panel/adminDashboard.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, delay, finalize, of, tap } from 'rxjs';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [CommonModule, MatIconModule, HttpClientModule,MatProgressSpinnerModule,AdminHeaderComponent],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent implements OnInit {

  cardData: any[] = [];
  // recentActivities: any[] = [];
  // quickActions: any[] = [];
  isLoading = false;
  userStore$ = this._authService.userStore$;

  constructor(private _teacherService: AdminDashboardService, 
	        private toastr: ToastrService,
			private _authService:AuthServiceService    
		) { }

  ngOnInit(): void {
    this.getUserDashboardInfo();
  }

  getUserDashboardInfo(): void {
    this.isLoading = true;

    this._teacherService.getDashboardInfo().pipe(
      tap((response: UsersDashboardInfoResponse) => {
        if (response?.Success && response.Data) {
          const data = response.Data;

          this.cardData = [
            { title: 'Total Teachers', value: data.total_teachers, icon: 'groups' },
            { title: 'Total Students', value: data.total_students, icon: 'school' },
            { title: 'Total Batches', value: data.total_batches, icon: 'class' },
            { title: 'Total Classrooms', value: data.total_classrooms, icon: 'menu_book' },
            { title: 'AI Courses Generated', value: data.total_ai_courses, icon: 'smart_toy' },
            { title: 'Manual Courses', value: data.total_manual_courses, icon: 'edit_note' },
            { title: 'Total Quizzes', value: data.total_quizzes, icon: 'assignment' },
            { title: 'Quizzes Taken', value: data.total_quizzes_attempted, icon: 'check_circle' },
          ];
        }
      }),
      catchError(() => {
        this.toastr.error('Failed to load dashboard information.', 'Error');
        return of(null);
      }),
      finalize(() => (this.isLoading = false))
    ).subscribe();
  }

}